import React from 'react';
import { Spacer } from '../Spacer/Spacer';
export const Form = ({ onSubmit, children }) => {
    const submit = (event) => {
        event.preventDefault();
        onSubmit();
    };
    return (React.createElement("form", { onSubmit: (event) => submit(event) },
        React.createElement(Spacer, { child: 'md' }, children)));
};
